<script lang="ts">
  /**
   * A community's Skool logo, with an initial-letter tile when we have no image.
   *
   * Written once because it was already written twice — `CommunitySelect` and the
   * `AdminHealth` fleet table each carried their own `{#snippet logo(...)}` with the
   * same markup and the same two branches, differing only in the community TYPE they
   * accepted and the character they fell back to. Both are now this component.
   *
   * It takes the two SCALARS it renders rather than a community object, on purpose:
   * four different shapes carry a logo in this app (`Community`, `MeCommunity`,
   * `PipelineCommunity`, `CommunityRef` — which has no logo at all), and a
   * component that named one of them would have to be widened or copied for the next.
   *
   * `size` is a Tailwind box utility passed as a LITERAL string by the caller
   * ('h-5 w-5', 'h-9 w-9') — Tailwind scans source text, so a computed class name
   * would not be emitted.
   */
  let {
    name = null,
    logoUrl = null,
    size = 'h-5 w-5',
    textClass = 'text-[0.7rem]',
    fallback = '?',
  }: {
    // `| undefined` is explicit because `exactOptionalPropertyTypes` is on and every
    // caller reads these off an optional community (`c?.name`, `c?.logo_url`).
    name?: string | null | undefined;
    logoUrl?: string | null | undefined;
    size?: string;
    /** Sizing for the fallback initial — scale it with `size`, or the letter floats. */
    textClass?: string;
    /** Shown when there is no logo AND no name to take an initial from. */
    fallback?: string;
  } = $props();
</script>

<!-- A community's logo and the initial of its name both name the community, which
     the redaction policy treats as identifying. -->
{#if logoUrl}
  <img src={logoUrl} alt="" class="redact {size} shrink-0 rounded object-cover" loading="lazy" />
{:else}
  <span
    class="redact {size} {textClass} grid shrink-0 place-items-center rounded bg-primary/12 font-mono font-bold text-primary"
    >{name?.[0]?.toUpperCase() ?? fallback}</span
  >
{/if}
